/**
 * Object.keys, but with better type inference.
 */
export const typedKeys = <T extends object>(object: T) =>
  Object.keys(object) as T extends Record<infer Keys, any> ? Keys[] : string[];
